//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { loadProfessionalScheduleSuccess, saveProfessionalScheduleSuccess } from './professional-schedule.actions';


export interface IProfessionalScheduleState {
  lista: any[];
}

const initialState: IProfessionalScheduleState = {
  lista: [],
};

export const professionalScheduleReducer = createReducer(
  initialState,
  on(loadProfessionalScheduleSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
  })),
  on(saveProfessionalScheduleSuccess, (state, { professionalSchedule }) => ({
    ...state,
    lista: [...state.lista, professionalSchedule],
  }))
);
//colocar como parametro o professionalReducer lá no app.module
//agora criamos o selector em um novo arquivo
